/* NIGHT OPERATORS PREDATOR kit add-on rows: the picture and the name open that product's page (new tab, so the picks on
   this page stay), plus a small "View product" link under the name. NEW FILE, 20 Oct 2026 (Bon: every add-on row on the
   store). The rows are <label> elements, and a tap on a link inside a label opens the link and never ticks the box; the
   links also stop the click so no row script sees it. Loaded once by templates/product.predator-live.json.
   Edits nothing in predator-kit.js, ngal-upsell.js or pvs14-upsell.js. No em or en dashes. */
(function () {
  if (window.__noPkLinks) return; window.__noPkLinks = true;
  var MAP = { bridge: 'predator-dual-dovetail-bridge', lens13: 'predator-13mm-distance-lens', g24: 'g24-style-nvg-helmet-mount',
    flip: 'predator-flip-to-side-qd-mount', p14: 'pvs-14-night-vision-monocular', ngal: 'ngal-ir-laser-illuminator', helmet: 'fast-sf-helmet' };
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function keyOf(row) {
    if (row.hasAttribute('data-no-pk-bridge')) return 'bridge';
    var a = row.getAttribute('data-no-pk-addon'); if (a) return a;
    if (row.hasAttribute('data-no-p14-row')) return 'p14';
    if (row.hasAttribute('data-no-ngal-row')) return 'ngal';
    if (row.querySelector('[data-no-pk-helmet-img]')) return 'helmet';
    return null;
  }
  function handleOf(row, key) {
    if (key === 'helmet') {
      /* the helmet row follows the visitor's market; read the handle the block printed when it has one */
      var box = row.closest('[data-no-pk-helmet]') || row.parentNode;
      var d = box && box.querySelector('script[type="application/json"]');
      try { var j = d ? JSON.parse(d.textContent) : null; if (j && j.handle) return j.handle; } catch (e) { /* use the map */ }
    }
    return MAP[key];
  }
  function stop(a) { a.addEventListener('click', function (e) { e.stopPropagation(); }); }
  function link(cls, href, label) {
    var a = document.createElement('a');
    a.className = cls; a.href = href; a.target = '_blank'; a.rel = 'noopener';
    if (label) a.textContent = label;
    stop(a); return a;
  }
  function wire(row) {
    if (row.__noPkLinked) return; row.__noPkLinked = true;
    var key = keyOf(row), h = key && handleOf(row, key); if (!h) return;
    var url = root() + 'products/' + h;
    var thumb = row.querySelector('img.no-pk__thumb, .no-p14__thumb');
    if (thumb && !thumb.closest('a')) {
      var pa = link('no-pk__plink', url); pa.tabIndex = -1; pa.setAttribute('aria-hidden', 'true');
      thumb.parentNode.insertBefore(pa, thumb); pa.appendChild(thumb);
    }
    var strong = row.querySelector('.no-pk__addon-text strong');
    if (strong && !strong.querySelector('a')) {
      var na = link('no-pk__nlink', url);
      while (strong.firstChild) na.appendChild(strong.firstChild);
      strong.appendChild(na);
      var va = link('no-pk__view', url, 'View product');
      strong.parentNode.insertBefore(va, strong.nextSibling);
    }
  }
  function css() {
    if (document.getElementById('no-pk-links-css')) return;
    var s = document.createElement('style'); s.id = 'no-pk-links-css';
    s.textContent = '.no-pk__plink{display:inline-flex;flex:0 0 auto;line-height:0;border-radius:8px}' +
      '.no-pk__nlink{color:inherit;text-decoration:none}.no-pk__nlink:hover{text-decoration:underline;text-underline-offset:3px}' +
      '.no-pk__view{display:inline-flex;align-items:center;align-self:flex-start;font-family:"JetBrains Mono",monospace;font-weight:700;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#237026;text-decoration:underline;text-underline-offset:3px;margin:2px 0}' +
      '@media (max-width:767px){.no-pk__nlink{display:inline-flex;align-items:center;min-height:40px;min-width:40px}.no-pk__view{min-height:40px;margin:0}.no-pk__plink{min-width:40px;min-height:40px;align-items:center;justify-content:center}}';
    document.head.appendChild(s);
  }
  function boot() {
    var rows = document.querySelectorAll('#no-predator-kit .no-pk__addon, .no-pk__addons .no-pk__addon');
    if (!rows.length) return;
    css();
    Array.prototype.forEach.call(rows, wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
})();
